import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/en/translations.json";
import translationHi from "./locales/hi/translations.json";
import translationTA from "./locales/ta/translations.json";
import translationML from "./locales/ml/translations.json";

const resources = {
  en: { translations: translationEN },
  hi: { translations: translationHi },
  ta: { translations: translationTA },
  ml: { translations: translationML },
};

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  detection: {
    order: ["htmlTag", "cookie", "localStorage", "path"],
    caches: ["cookie"],
  },
  react: { useSuspense: false },
  resources,
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["en","hi", "ta", "ml"];

export default i18n;
